/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_File_FormatInputs */

const en_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File Format`)
};

const es_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de archivo`)
};

const fr_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format de fichier`)
};

const de_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateiformat`)
};

const ja_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイル形式`)
};

const zh_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件格式`)
};

const ar_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`صيغة الملف`)
};

const id_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format File`)
};

const it_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato File`)
};

const ru_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Формат файла`)
};

const pt_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato de Arquivo`)
};

const ko_field_file_format = /** @type {(inputs: Field_File_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 형식`)
};

/**
* | output |
* | --- |
* | "File Format" |
*
* @param {Field_File_FormatInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_file_format = /** @type {((inputs?: Field_File_FormatInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_File_FormatInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_file_format(inputs)
	if (locale === "es") return es_field_file_format(inputs)
	if (locale === "fr") return fr_field_file_format(inputs)
	if (locale === "de") return de_field_file_format(inputs)
	if (locale === "ja") return ja_field_file_format(inputs)
	if (locale === "zh") return zh_field_file_format(inputs)
	if (locale === "ar") return ar_field_file_format(inputs)
	if (locale === "id") return id_field_file_format(inputs)
	if (locale === "it") return it_field_file_format(inputs)
	if (locale === "ru") return ru_field_file_format(inputs)
	if (locale === "pt") return pt_field_file_format(inputs)
	return ko_field_file_format(inputs)
});